var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgent = function SvgAgent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4 15V7c0-1.886 0-2.828.586-3.414S6.114 3 8 3h3m9 12v-.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M18 2c1.886 0 2.828 0 3.414.586S22 4.114 22 6v2c0 1.886 0 2.828-.586 3.414S19.886 12 18 12s-2.828 0-3.414-.586S14 9.886 14 8V6c0-1.886 0-2.828.586-3.414S16.114 2 18 2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18 9h.009"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.498 16.015 4.02 15h15.932l.55 1.015c1.443 2.662 1.803 3.993 1.254 4.989s-2.002.996-4.91.996H7.154c-2.909 0-4.363 0-4.911-.996-.549-.996-.19-2.327 1.254-4.989"
  })));
};
export default SvgAgent;